// @flow
import type { NotificationData } from 'common/modules/ui/domain/Notification';
import Notification from 'common/modules/ui/domain/Notification';
import type { EstimationProgressRequest, SalesEstimationSuccessData } from 'statsradio/modules/sales/domain/estimationProgress';

type SalesEstimationNotificationData = NotificationData & {
  estimationReference: string;
  estimationProgress: EstimationProgressRequest;
};

export default class SalesEstimationNotification extends Notification {
  estimationReference: string;
  estimationProgress: EstimationProgressRequest;

  constructor(data: SalesEstimationNotificationData) {
    super(data);
    this.estimationReference = data.estimationReference;
    this.estimationProgress = data.estimationProgress;
  }

  isRunning() {
    const { progress } = this.estimationProgress;
    return !progress.is('SUCCESS') && !progress.is('ERROR');
  }

  isInError() {
    const { progress } = this.estimationProgress;
    return progress.is('ERROR');
  }

  getTotalCost(): number | void {
    const { progress } = this.estimationProgress;

    if (progress.is('SUCCESS') && progress.data !== undefined) {
      // $FlowFixMe
      const estimationSuccessData: SalesEstimationSuccessData = this.estimationProgress.progress.data;

      return estimationSuccessData.totalCost;
    }

    return undefined;
  }

  getType() {
    return 'SALES_ESTIMATION';
  }

  getUrl() {
    const { progress } = this.estimationProgress;
    if (!progress.is('SUCCESS')) {
      return undefined;
    }

    return this.url;
  }

  clone() {
    return new SalesEstimationNotification(this);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/notifications/domain/SalesEstimationNotification.js